import type {
  DialogGlassBackgroundProps,
  DialogScrimBlurProps,
} from './DialogGlassBackground.types';

/**
 * Frosted-glass layers for the Dialog — WEB no-ops.
 *
 * The web panel gets its frost from the CVA's `web:backdrop-blur-[27px]` on
 * the panel element itself, and the overlay from `backdrop-blur-[8px]` in
 * `Dialog.tsx`, so there is nothing extra to render here. The native siblings
 * (`DialogGlassBackground.native.tsx`) draw real `expo-blur` BlurViews, since
 * React Native has no `backdrop-filter`.
 */
export function DialogGlassBackground(_props: DialogGlassBackgroundProps) {
  return null;
}

export function DialogScrimBlur(_props: DialogScrimBlurProps) {
  return null;
}
